import React from 'react';
export const SocialProof: React.FC = () => {
  return <section className="py-5 text-center text-sm tracking-wide" style={{
    borderTop: '1px solid var(--border-subtle)',
    borderBottom: '1px solid var(--border-subtle)',
    color: 'var(--text-muted)'
  }} data-id="element-163">
      <div className="container mx-auto px-4" data-id="element-164">
        Edición 2026 · Precios referenciados al{' '}
        <strong style={{
        color: 'var(--gold)',
        fontWeight: 600
      }} data-id="element-165">
          dólar blue
        </strong>{' '}
        · Incluye plan de acción de 7 días
      </div>
    </section>;
};